// extracted by mini-css-extract-plugin
export default {"leadCollectContainer":"LeadCollect_leadCollectContainer__PCGPM"};